import { faAngleDown } from "@jewlr/pro-solid-svg-icons/faAngleDown"
import { faAngleUp } from "@jewlr/pro-solid-svg-icons/faAngleUp"
import { Expand } from "@jewlr/storybook/animate"
import { Box, FontAwesomeIcon, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { useState, useEffect } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import AboutDiamonds from "./about-diamonds"
import DiamondInfo from "./diamond-info"
import stepDescriptionData from "./step-description"

const Container = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.grey45};
  border-top: 1px solid ${(props) => props.theme.colors.grey45};
  margin: 32px auto;
  padding: 16px 8px;
  text-align: center;
`

const InternalAdditionalInfo = ({ currentStepName }) => {
  const [showContent, toggleContent] = useState(false)
  useEffect(() => {
    toggleContent(false)
  }, [currentStepName])

  return (
    <Container>
      <Typography
        as="h4"
        bold
        fontSize={18}
        onClick={() => toggleContent(!showContent)}
        pointer
      >
        {stepDescriptionData[currentStepName].title}{" "}
        <FontAwesomeIcon
          icon={showContent ? faAngleUp : faAngleDown}
          style={{ verticalAlign: "bottom" }}
        />
      </Typography>
      <Expand show={showContent}>
        <Box mt={3}>
          {currentStepName === "choose_stone" ? (
            <AboutDiamonds />
          ) : (
            <DiamondInfo
              content={stepDescriptionData[currentStepName]}
              currentStepName={currentStepName}
            />
          )}
        </Box>
      </Expand>
    </Container>
  )
}

const mapStateToProps = (state) => {
  return {
    currentStepName: state.diamondUI.steps[state.diamondUI.currentStep],
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalAdditionalInfo.propTypes = {
  currentStepName: PropTypes.string,
}

const AdditionalInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalAdditionalInfo)

export default AdditionalInfo
